<div class="checkbox-item">
  <div class="checkbox-error-text">
    <nibtravel-validation
      [validations]="validations"
      [control]="ngControl.control"
      [host]="formComponent"
      [errorMessageOnFormGroup]="errorMessageOnFormGroup"
      [enableDistinctUntilChanged]="enableDistinctUntilChanged"
      (errorEmitter)="onError($event)"
      *ngIf="validations"
    ></nibtravel-validation>
  </div>

  <input
    [idOrDefault]="inputId"
    [attr.data-e2e]="e2eId"
    [class]="'checkbox-input'"
    [value]="value"
    [checked]="checked"
    [type]="type"
    [name]="inputName"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    (change)="onChange($event.target.checked)"
    (blur)="onBlur()"
    (focus)="onFocus($event.target.checked)"
  />
  <label
    [attr.for]="inputId"
    [attr.aria-label]="label"
    [idOrDefault]="labelId"
    class="checkbox-label"
  >
    <span class="checkbox-button">
      <nibtravel-icon icon="tick" size="xlg"></nibtravel-icon>
    </span>
    <div class="checkbox-label-text">
      <ng-container *ngIf="label; else altContent">
        {{ label }}
      </ng-container>
      <ng-template #altContent>
        <ng-content></ng-content>
      </ng-template>
    </div>
  </label>
</div>
